/**
 * Author:WYX
 * Time:2020-04-28
 */
'use strict';
angular.module('changeAllLayoutModule', []).controller('changeAllLayoutCtrl', [
    '$scope',
    '$filter',
    '$validation',
    '$stateParams',
    '$modalInstance',
    'modalDialog',
    'transferData',
    'trsHttpService',
    'trsspliceString',
    'editingCenterService',
    function ($scope, $filter, $validation, $stateParams, $modalInstance, modalDialog, transferData, trsHttpService, trsspliceString, editingCenterService) {
        initStatus();
        initData();

        /**
         * [initStatus description]
         *
         * @return  {[type]}  [return description]
         */
        function initStatus() {
            // 传递的选择的项目
            $scope.items = transferData.selectedArr;
            $scope.status = {
                date: ''
            };
            $scope.manuInfos = {
                caibian: '',
                dieci: '',
            };
            // 意见
            $scope.option = '';
            $scope.data = {
                paperMsg: {}
            };
        }

        /**
         * [initData description]初始化数据
         *
         * @return  {[type]}  [return description]
         */ 
        function initData() {
            getPubDate();
            getDiecis();
            editingCenterService.getSiteInfo($stateParams.paperid).then(function(data) {
                $scope.data.paperMsg = data;
            });
        }

        /**
         * [getPubDate description]获取默认时间
         *
         * @return  {[type]}  [return description]
         */
        function getPubDate() {
            var time = Number($filter('date')(new Date(), 'HH'));
            // 如果系统时间大于8点了,就显示第二天上版
            if (time > 8) {
                $scope.status.date = new Date().setDate(new Date().getDate() + 1);
            } else {
                // 小于8点,就显示当天上版
                $scope.status.date = new Date().setDate(new Date().getDate());
            }
        }

        /**
         * [getDiecis description]获取叠次列表
         *
         * @return  {[type]}  [return description]
         */
        function getDiecis() {
            var params = {
                serviceid: 'mlf_paper',
                methodname: 'queryDieCis',
                PaperId: $stateParams.paperid || transferData.selectedArr[0].SITEID,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                $scope.dieciItems = data;
                if (data.length) {
                    $scope.dieciClick(0);
                }
            });
        }

        // 叠次选择切换相应的采编版面
        $scope.dieciClick = function (curItem) {
            $scope.manuInfos.caibian = '';
            $scope.selectedCaibian = '';
            $scope.dieciSelected = curItem;
            $scope.manuInfos.dieci = '';
            var dieciStr = trsspliceString.spliceString($scope.dieciItems, 'CHANNELID', ',');
            var dieciArray = dieciStr.split(',');
            $scope.selectedDieci = dieciArray[curItem];
            getCBLayout();
        };

        /**
         * [getCBLayout description]根据叠次名获取采编版面列表
         *
         * @return  {[type]}  [return description]
         */
        function getCBLayout() {
            var params = {
                serviceid: 'mlf_paper',
                methodname: $scope.data.paperMsg.ISZHAOPAI === '0' ? 'queryCaiBianBanMians' : 'queryZhaoPaiBanMians',
                PaperId: $stateParams.paperid || transferData.selectedArr[0].SITEID,
                DieCiId: $scope.selectedDieci,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                $scope.cbItems = data;
            });
        }

        // 选择采编版面,获取版面id
        $scope.caibianClick = function (curItem, index) {
            $scope.caibianSelected = curItem;
            $scope.manuInfos.caibian = '';
            var caibianStr = trsspliceString.spliceString($scope.cbItems, 'CHANNELID', ',');
            var caibianArray = caibianStr.split(',');
            $scope.selectedCaibian = caibianArray[index];
        };

        // 确定
        $scope.confirm = function () {
            var dateStr = $filter('date')($scope.status.date, 'yyyy-MM-dd').toString();
            var returnData = {
                dateStr: dateStr,
                banmianid: $scope.selectedCaibian,
                option: $scope.option
            };
            $validation
                .validate($scope.changeAllLayoutForm)
                .success(function () {
                    if ($scope.selectedCaibian === '' || !$scope.selectedCaibian) {
                        modalDialog.alertType('提交失败', '请选择提交版面', 'error', false, function () { });
                    } else {
                        $modalInstance.close(returnData);
                        $scope.items = '';
                    }
                })
                .error(function () {
                    modalDialog.alertType('提交失败', '请输入正确的数据格式', 'error', false, function () { });
                });
        };

        $scope.cancel = function () {
            $modalInstance.close(false);
        };
    },
]);
